// Deep Space scene registry. Each scene = { accent, chip, sky, html }:
//   accent/chip — colour-name keys (resolved in DeepSpaceEventCard's C map): title/badge + chip.
//   sky         — props for <SpaceSky> (null → no sky, e.g. photographic image scenes).
//   html        — foreground "actor" markup injected into .ds-card__actor (over the sky).
// Ported from design handoff 9. Bug + the 12 status scenes live in their own modules.
import { DS_BUG } from "./dsBugScene.js";
import { DS_STATUS } from "./dsStatusScenes.js";

// ── Feature: a satellite flies a single arc from the bottom-right up into the moon, shrinking + fading.
const FEATURE_HTML = `
<div class="dsf-sat" style="position:absolute; top:0; left:0; width:190px; height:150px; offset-path:path('M 740 380 C 470 372 338 232 393 91'); offset-rotate:0deg; offset-anchor:center; animation:dsf-sattravel 15s cubic-bezier(.25,.55,.15,1) infinite;">
 <div style="width:190px; height:150px; animation:dsf-satfloat 7s ease-in-out infinite;">
  <svg viewBox="0 0 190 150" width="190" height="150" style="overflow:visible;">
    <path d="M95 78 L58 150 L132 150 Z" fill="url(#dsf-beamgrad)" opacity="0.5" style="transform-origin:95px 78px; animation:dsf-beam 3s ease-in-out infinite;"></path>
    <defs>
      <linearGradient id="dsf-beamgrad" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#35e0d0" stop-opacity=".8"/><stop offset="1" stop-color="#35e0d0" stop-opacity="0"/></linearGradient>
      <linearGradient id="dsf-panelgrad" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#2b4a7a"/><stop offset="1" stop-color="#12233f"/></linearGradient>
    </defs>
    <g style="transform-origin:95px 70px; animation:dsf-panel 1.1s cubic-bezier(.2,.8,.2,1) both;">
      <rect x="10" y="58" width="56" height="26" rx="2" fill="url(#dsf-panelgrad)" stroke="#5fa8ff" stroke-width="1"></rect>
      <line x1="24" y1="58" x2="24" y2="84" stroke="#0b1322" stroke-width="1"/><line x1="38" y1="58" x2="38" y2="84" stroke="#0b1322" stroke-width="1"/><line x1="52" y1="58" x2="52" y2="84" stroke="#0b1322" stroke-width="1"/>
    </g>
    <g style="transform-origin:95px 70px; animation:dsf-panel 1.1s cubic-bezier(.2,.8,.2,1) .12s both;">
      <rect x="124" y="58" width="56" height="26" rx="2" fill="url(#dsf-panelgrad)" stroke="#5fa8ff" stroke-width="1"></rect>
      <line x1="138" y1="58" x2="138" y2="84" stroke="#0b1322" stroke-width="1"/><line x1="152" y1="58" x2="152" y2="84" stroke="#0b1322" stroke-width="1"/><line x1="166" y1="58" x2="166" y2="84" stroke="#0b1322" stroke-width="1"/>
    </g>
    <rect x="72" y="52" width="46" height="38" rx="6" fill="#dfe9f4" stroke="#9fb4cc" stroke-width="1"></rect>
    <rect x="80" y="60" width="30" height="22" rx="3" fill="#0b1322"></rect>
    <circle cx="95" cy="71" r="6" fill="#35e0d0" opacity="0.9"></circle>
    <ellipse cx="95" cy="40" rx="17" ry="7" fill="#eaf3ff" stroke="#9fb4cc" stroke-width="1"></ellipse>
    <line x1="95" y1="47" x2="95" y2="58" stroke="#9fb4cc" stroke-width="2"/>
    <circle cx="95" cy="38" r="2.4" fill="#ffb454" style="animation:dsf-blink 1.6s ease-in-out infinite;"></circle>
    <circle cx="78" cy="86" r="2" fill="#ff6a7a" style="animation:dsf-blink 1.1s ease-in-out infinite;"></circle>
    <circle cx="112" cy="86" r="2" fill="#4fd18a" style="animation:dsf-blink 1.1s ease-in-out .55s infinite;"></circle>
    <circle cx="30" cy="71" r="1.6" fill="#eaf3ff" style="animation:dsf-blink 1.8s ease-in-out .3s infinite;"></circle>
    <circle cx="160" cy="71" r="1.6" fill="#eaf3ff" style="animation:dsf-blink 1.8s ease-in-out .9s infinite;"></circle>
  </svg>
 </div>
</div>`;

export const DS_FEATURE = {
  accent: "teal", chip: "amber",
  sky: { planet: true, moon: true, shooting: true },
  html: FEATURE_HTML,
};

export { DS_BUG, DS_STATUS };
